import { InitialLocationCallback } from '../../map-container/map-initial-location.provider';
import { MapItemDetailsProvider } from '../../map-item-details-provider/map-item-details.provider';
import { MapComponent } from '../../map.component';
import { MapFlow } from '../map.flow';

export class MapSelectItemFlow extends MapFlow {
  private alreadySelected = false;

  constructor(
    mapComponent: MapComponent,
    private itemDetailsProvider: MapItemDetailsProvider,
    private selectedItemId: string,
  ) {
    super(mapComponent);
  }

  public override activate() {
    this.mapComponent.toggleButtonVisibility();
    this.mapComponent.onFilterChanged(this.itemDetailsProvider.filter);
  }

  public override deactivate() {
    this.mapComponent.toggleButtonVisibility();
    this.mapComponent.mediator.reset();
  }

  public override getInitialLocation(successCallback: InitialLocationCallback) {
    this.itemDetailsProvider
      .fetchLocationForItemById(this.selectedItemId)
      .then((location) => {
        successCallback(location, 13);
      })
      .catch((_error) => {
        // Should be empty because the error will be handled on the Interceptor level.
      });
  }

  public override markersWereUpdated() {
    if (!this.alreadySelected && this.selectedItemId && this.mapComponent.mapMarkers.markerExists(this.markerId)) {
      this.mapComponent.mediator.clickItem(this.markerId);
      this.alreadySelected = true;
    }
  }

  private get markerId(): string {
    return this.itemDetailsProvider.getMarkerIdByEntityId(this.selectedItemId);
  }
}
